(function($){
    var init = function() {
        let $modelName = $('#modelName'),
            stickySubmenu = document.getElementById('sticky-submenu');

        if( ! $modelName.length || stickySubmenu === null )
        {
            return;
        }

        let modelNameOffset = $modelName.offset().top;

        $(window).scroll(function () {
            let st = $(window).scrollTop();

            if (st > modelNameOffset)
            {
                return stickySubmenu.classList.add('show');
            }

            stickySubmenu.classList.remove('show');
        });
    };

    $(document).ready(init);
})(jQuery);